(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('agent-detail',
                {
                    url: '/:langcode/{path:agents|danisman|agentes}/:name/:id',
                    templateUrl: 'app/agents/agent-detail.html',
                    controller: 'AgentDetailController',

                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        id: { type: 'any', raw: true },
                        name: { type: 'any', raw: true },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("agent-detail");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'agents');
                        }],

                        LangProtect: ['routeHelpers', function(routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        user: ["userSvc", "$q", function (userSvc, $q) {
                            var defer = $q.defer();
                            userSvc.getUserInfo().then(function () {
                                defer.resolve(userSvc.info);
                            }, function () {
                                defer.resolve(null);
                            });
                            return defer.promise;
                        }],
                        agent: [
                            "agentApi",
                            "$transition$",
                            "user",
                            "$q",
                            "historyService",
                            function (agentApi, $transition$, user, $q, historyService) {
                                var defer = $q.defer();
                                // ID parametresinin boş olup olmadığını kontrol et
                                if (!$transition$.params().id || $transition$.params().id.toString().trim() === '') {
                                    $transition$.abort();
                                    $transition$.router.stateService.go("analysis.country.agents", { langcode: $transition$.params().langcode, country: "world" });
                                    defer.reject("ID parameter cannot be empty.");
                                    return defer.promise;
                                }

                                agentApi.get({ Language: window.langCode(), Id: $transition$.params().id, UserId: user ? user.Id : null }).$promise.then(function (result) {
                                    if (result.Results.length && (result.Results[0].ShareProfile || (user && user.Id === result.Results[0].Id))) {
                                        defer.resolve(result.Results[0]);
                                        historyService.set('agent', $transition$.params().id);
                                    }
                                    else {
                                        $transition$.abort();
                                        $transition$.router.stateService.go("analysis.country.agents", { langcode: $transition$.params().langcode, country: "world" });
                                    }
                                }, function () {
                                    $transition$.abort();
                                    $transition$.router.stateService.go("analysis.country.agents", { langcode: $transition$.params().langcode, country: "world" });
                                });
                                return defer.promise;
                            }
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("agents");
                            $translatePartialLoader.addPart('consult_expert');
                            return $translate.refresh();
                        }],
                        title: ['agent', '$translate', function (agent, $translate) {
                            return $translate("c_agent1").then(function (res) {
                                if (agent && agent.Regions && agent.Regions.features.length) {
                                    let activeRegion = agent.Regions.features.find(f => !f.properties.isManuelRegion);
                                    return activeRegion.properties.CityName + " " + activeRegion.properties.CountyName + " " + res + " " + agent.Name + " " + agent.Surname;
                                }
                                else
                                    return res + " " + agent.Name + " " + agent.Surname;
                            });
                        }],
                        description: ['agent', '$translate', function (agent, $translate) {
                            if (agent && agent.Regions && agent.Regions.features.length) {
                                return $translate("c_agent2").then(function (res) {
                                    return $translate("c_agent3").then(function (res2) {
                                        let activeRegion = agent.Regions.features.find(f => !f.properties.isManuelRegion);
                                        return activeRegion.properties.CityName + " " + activeRegion.properties.CountyName + " " + res + " " + agent.Name + " " + agent.Surname + " " + res2;
                                    });
                                });
                            }
                            else
                                return $translate("c_agent4").then(function (res) {
                                    return $translate("c_agent3").then(function (res2) {
                                        return res + " " + agent.Name + " " + agent.Surname + " " + res2;
                                    });
                                });
                        }]
                    },
                    metaTags: {
                        title: '{{title}}',
                        robots: 'index, follow',
                        description: '{{description}}',
                        properties: {
                            'og:image': ['agent', function (agent) { return agent && agent.AvatarUrl ? agent.AvatarUrl.replace('https://', 'http://') : "http://www.endeksa.com/share3.jpg"; }],
                            'og:image:secure_url': ['agent', function (agent) { return agent && agent.AvatarUrl ? agent.AvatarUrl.replace('http://', 'https://') : "https://www.endeksa.com/share3.jpg"; }],
                            'og:type': 'website'
                        }
                    }
                })
            .state('agent-profile',
                {
                    url: '/:langcode/{path:agents|danisman|agentes}/profil',
                    params: {
                        path: ['$translate', function ($translate) {
                            return $translate.instant("agent-profile");
                        }],
                    },
                    resolve: {

                        LangProtect: ['routeHelpers', function(routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        user: ["userSvc", "$q", "$transition$", "$translate", function (userSvc, $q, $transition$, $translate) {
                            var defer = $q.defer();
                            userSvc.getUserInfo().then(function () {
                                $transition$.abort();
                                $transition$.router.stateService.go("agent-detail", { name: normalizeAddress(userSvc.info.Details.profile.name.trim()) + '-' + normalizeAddress(userSvc.info.Details.profile.surName.trim()), path: $translate.instant("agent-detail"), id: userSvc.info.Id, langcode: $transition$.params().langcode });
                                deferred.resolve();
                            }, function () {
                                $transition$.abort();
                                $transition$.router.stateService.go("signin", { langcode: $transition$.params().langcode });
                                defer.resolve(null);
                            });
                            return defer.promise;
                        }]
                    },
                    metaTags: {
                        robots: 'noindex, nofollow'
                    }
                });
    }]);

})();
